<template>
<div class="coordinates">
  <div id="latlng">
    <strong><span>Latitude: </span></strong>
    <span id="lat"></span>
    &nbsp;&nbsp;&nbsp;
    <strong><span>Longitude: </span></strong>
    <span id="lng"></span>
    &nbsp;&nbsp;&nbsp;
    <strong><span>Elevation: </span></strong>
    <span id="elevation"></span>
  </div>
</div>
</template>
<script>
/* eslint-disable vue/multi-word-component-names */
export default {
  name: 'coordinates',
};
</script>
<style>
.coordinates #latlng{
  display: block;
  position: absolute;
  z-index: 1000;
  margin-left: auto;
  margin-right: auto;
  left: 8%;
  width: 55%;
  padding: 10px;
  border: none;
  /* border-radius: 3px; */
  font-size: 14px;
  text-align: center;
  opacity: 0.85;
  color: #f2f2f2;
  background: #323232;
}
</style>
